var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43626 15V8.16893H7.91462L8.28301 5.49434H5.43626V3.79074C5.43626 3.01895 5.66751 2.49053 6.85874 2.49053H8.36816V0.105991C7.63374 0.0328054 6.89553 -0.00253208 6.15691 0.000140994C3.96627 0.000140994 2.46223 1.24367 2.46223 3.52653V5.48934H0V8.16392H2.4676V15H5.43626Z",
    fill: "#C4E332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.177800f03cc7cfaae01f7c2fd3d4a9a0.svg";
export { ForwardRef as ReactComponent };